const backendBase = (process.env.REACT_APP_BACKEND_URL || "").trim();
const isProductionMikelMedia =
  typeof window !== "undefined" &&
  /(^|\.)mikel\.media$/i.test(window.location.hostname);

// In production we proxy `/api/*` through the frontend deployment to avoid
// cross-origin preflight issues against the separate backend project.
export const API_BASE =
  isProductionMikelMedia ? "/api" : backendBase ? `${backendBase}/api` : "/api";
